var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.692 8.30602C18.2814 7.89799 17.6156 7.89799 17.2049 8.30602L12 13.4776L6.7951 8.30602C6.38445 7.89799 5.71865 7.89799 5.30799 8.30602C4.89734 8.71404 4.89734 9.37559 5.30799 9.78361L11.2564 15.694C11.6671 16.102 12.3329 16.102 12.7436 15.694L18.692 9.78361C19.1027 9.37559 19.1027 8.71405 18.692 8.30602Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.16cafd36642b7276b39f1e2ac747f8ac.svg";
export { ForwardRef as ReactComponent };